<template>
  <b-card no-body>
    <!--<b-card-text>{{selected}}</b-card-text>-->
    <b-row>
      <b-col>
        <b-overlay :show="loading">
          <b-form-group label="Todas los Eventos">
            <b-form-checkbox
          v-for="evento in items"
          :key="evento.id"
          v-model="elements"
          :value="evento"
          name="flavour-3a"
        >
          {{ evento.entrada.titulo }}
        </b-form-checkbox>
          </b-form-group>
        </b-overlay>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import axios from "@axios";
import {
  BCard,
  BCardText,
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BFormCheckbox,
  VBTooltip,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
export default {
  components: {
    BCard,
    BCardText,
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BOverlay,
    vSelect,
    BFormCheckbox,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      items: [],

      selected: [],
      filter: null,
      filterOn: [],

      loading: false,
      item: [],
    };
  },
  created() {
    this.loading = true;
    this.$store.dispatch("aparienciaMenus/updateElementsEventos", []);

    this.getEventos();
  },
  computed: {
    elements: {
      get() {
        return this.$store.state.aparienciaMenus.eventos_elementos;
      },
      set(value) {
        this.$store.dispatch("aparienciaMenus/updateElementsEventos", value);
      }
    }
  },
  methods: {
    getEventos() {
      axios
        .get(`/menus/listar/eventos`)
        .then((res) => {
          this.items = res.data.data;

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
